export class QueryModel {
    pageSize: number;
    page: number;
    queryResult: any;
    orderBy: any;
    isSortAscending: boolean;
    totalItems: number;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/paginationquery.model.ts